import { ActionTableState } from "../../action-table/action-table"
import WorktimeTable from "../../fragments/worktime-table"


function EmployeeWorktime({ employeeId }) {
  return (<WorktimeTable as={ActionTableState} preselectedEmployeeId={employeeId} />)
}

export default EmployeeWorktime